module.exports = __webpack_public_path__ + "img/art-55.42bcfaf4.png";